/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Card, Form, Input, Button, Flex, message } from "antd";
import {
  Row,
  Col,
  Space,
  Select,
  Divider,
  Badge,
  Typography,
  Upload,
  InputNumber,
} from "antd";

import { SaveFilled, SearchOutlined } from "@ant-design/icons";

import { ButtonBack, uploadButton } from "../../../components/button";
import ModalPackagingType from "../../../components/modal/ERP/pk/ModalPackagingType";
import ModalUnit from "../../../components/modal/ERP/unit/ModalUnit.jsx";

import PackagingService from "../../../service/ERP/Packaging.service";
import { useLocation, useNavigate } from "react-router";
import { delay, BACKEND_URL_MAIN } from "../../../utils/util";
import OptionService from "../../../service/ERP/Options.service";
import Swal from "sweetalert2";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const pkservice = PackagingService();
const opService = OptionService();

const from = "/ERP/packaging";
const PackagingManage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { Text } = Typography;
  const { config } = location.state || { config: null };
  const [form] = Form.useForm();

  const [formDetail, setFormDetail] = useState([]);
  const [optionPrefix, setOptionPrefix] = useState([]);

  const [openModalPackagingType, setOpenModalPackgingType] = useState(false);

  const [openModalUnit, setOpenModalUnit] = useState(false);
  const [prefixCode, setPrefixCode] = useState(null);
  const [pkCode, setPkCode] = useState("");

  /* โหมดดูอย่างเดียว — ปิดการแก้ไขทั้งฟอร์ม ซ่อนปุ่มบันทึก */
  const isView = config?.action === "view";

  /// upload image
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("Preview");

  // const [packageTypeOption, setPackageTypeOption] = useState([]);
  const init = async () => {
    if (config?.action !== "create") {
      pkservice
        .get(config?.code)
        .then(async (res) => {
          const { data: detail, file } = res.data;
          
                    const init = {
                      ...detail,
                    };
          
                    setFormDetail(init);
                    form.setFieldsValue({ ...init });
                    form.setFieldValue("pk_code1", detail.pk_code);
          
                    let fileurl = file.map((data) => ({
                      ...data,
                      file_name:
                        `${BACKEND_URL_MAIN}/uploads/ERP/Items/` +
                        form.getFieldValue("pk_code") +
                        "/" +
                        data.file_name,
                    }));
                    // console.log(fileurl) ;
                    const formattedFileList = fileurl.map((data) => ({
                      img_id: data.img_id,
                      uid: data.uid,
                      name: data.name,
                      status: "done",
                      url: data.file_name,
                    }));
                    setFileList(formattedFileList);
                    form.setFieldsValue({ prod_img: formattedFileList });
                  })
                  .catch((err) => {
                    console.log(err);
                    message.error("Request error!");
                  });
    }
  };

  useEffect(() => {
    init();
    GetPrefix();
    return () => {};
  }, []);

  useEffect(() => {
    fnsetPKcode(); // อัปเดตค่า pkCode เมื่อฟอร์มเปลี่ยนแปลง
    // alert(pkCode);
  }, [form.getFieldValue("pk_code")]);

  const handlePreview = async (file) => {
    // console.log(file)
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    // setPreviewTitle(""
    //   // file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    // );
  };

  const handleRemove = (file) => {
    const newFileList = fileList.filter((f) => f.uid !== file.uid);
    setFileList(newFileList);
    //message.success(`File deleted successfully`);
  };

  const onRemove = (file) => {
    // console.log(file);
    //debugger
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const formData_Del = new FormData();
          formData_Del.append("img_id", file.img_id);
          formData_Del.append("file", file);
          formData_Del.append("uid", file.uid);
          formData_Del.append("stcode", form.getFieldValue("pk_code"));
          formData_Del.append("filename", file.name);

          const actions =
            config?.action !== "create"
              ? pkservice.deletePicUpdate(formData_Del)
              : pkservice.deletePic(formData_Del);

          actions.then(async (res) => {
            //debugger
            let { status, data } = res;
            if (status === 200 && data.status === "1") {
              handleRemove(file);
            } else {
              // alert(data.message)
            }
          });
        } catch (error) {
          message.error("Failed to delete file");
        }
      }
    });

    // console.log(fileList);
  };

  const onUploadSuccess = (file) => {
    //debugger
    // alert(`${BACKEND_URL_MAIN}/uploads/` + file.uid + "_" + file.name);
    const newFile = {
      uid: file.uid,
      name: file.name,
      status: "done",
      url:
        `${BACKEND_URL_MAIN}/uploads/ERP/Items/` +
        form.getFieldValue("pk_code") +
        "/" +
        "Item_Pic" +
        "_" +
        file.name,
    };
    setFileList((prevFileList) => [...prevFileList, newFile]);
    // console.log(file);
    // console.log('-----');
    // console.log(fileList);
  };

  const fnsetPKcode = () => {
    setPkCode(
      (form.getFieldValue("prefixLabel") !== undefined
        ? form.getFieldValue("prefixLabel")
        : "") +
        (form.getFieldValue("prefixLabel") !== undefined &&
        form.getFieldValue("pk_code") !== undefined
          ? "-"
          : "") +
        (form.getFieldValue("pk_code") !== undefined
          ? form.getFieldValue("pk_code")
          : "")
    ); // อัปเดตค่า pkCode เมื่อฟอร์มเปลี่ยนแปลง
  };

  const GetPrefix = () => {
    opService.optionsRuncode({ p: "packaging" }).then((res) => {
      let { data } = res.data;
      // let code = data.run_number
      setOptionPrefix(data);
    });
  };

  const handleChoosedPackagingType = (v) => {
    // console.log(v)
    const f = form.getFieldsValue();
    const val = {
      ...formDetail,
      ...f,
      pktype_id: v.pktype_id,
      pktype_name: v.pktype_name,
    };

    setFormDetail(val);

    form.setFieldsValue(val);
  };

  const handleChoosedUnit = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      unit: value.unitname,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const handleConfirm = () => {
    form.validateFields().then((v) => {
      const parm = {
        ...formDetail,
        ...form.getFieldsValue(),
        prefixLabel: form.getFieldValue("prefixLabel"),
      };
      const actions =
        config?.action !== "create"
          ? pkservice.update(parm)
          : pkservice.create(parm);
      // console.log(parm)

      actions
        .then(async (r) => {
          message.success("Request success.");

          navigate(from, { replace: true });
          await delay(300);
          // console.clear();
        })
        .catch((err) => {
          console.warn(err);
          const data = err?.response?.data;
          message.error(data?.message || "error request");
        });
    });
  };

  const dividerProp = {
    orientation: "left",
    style: { marginBlock: 10 },
    className: "!border-black",
  };

  const prefixSelector = (
    <Form.Item name="prefixid" noStyle>
      <Select
        style={{
          width: 350,
          textAlign: "left",
          paddingLeft: "10px",
        }}
        onChange={(v, l) => {
          form.setFieldValue("prefixLabel", l.text);
          // หรือเก็บใน state
          setPrefixCode(l.id);
          opService
            .optionsGetLastcode({ p: "packaging", id: v })
            .then((res) => {
              let { data } = res;
              setPrefixCode(data.data);
              const val = {
                ...formDetail,
                prefix: l.text,
              };
              setFormDetail(val);
            });
          fnsetPKcode();
        }}
        options={optionPrefix.map((item) => ({
          value: item.id,
          label: item.value + " - " + item.definition,
          text: item.value,
        }))}
      ></Select>
    </Form.Item>
  );

  let redcode = (
    <>
      {pkCode && pkCode !== "NaN" && (
        <span style={{ paddingLeft: "20px" }}>
          {"ตัวอย่างรหัสใหม่ " + pkCode}
        </span>
      )}
      <span style={{ color: "red", paddingLeft: "10px" }}>
        {prefixCode !== null ? " รหัสล่าสุด " + prefixCode : ""}
      </span>
    </>
  );

  const propsAdd = {
    customRequest: async ({ file, onSuccess, onError }) => {
      if (
        form.getFieldValue("pk_code") !== "" &&
        form.getFieldValue("pk_code") !== undefined
      ) {
        // console.log(fileList);
        const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif"]; // รายการสกุลไฟล์ที่อนุญาต
        const fileExtension = file.name.slice(
          ((file.name.lastIndexOf(".") - 1) >>> 0) + 2
        ); // สกุลไฟล์ของไฟล์ที่อัพโหลด
        if (!allowedExtensions.includes(`.${fileExtension.toLowerCase()}`)) {
          message.error("สกุลไฟล์ไม่ถูกต้อง");
          onError();
          return false;
        } else {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("uid", file.uid);
          formData.append("stcode", form.getFieldValue("pk_code"));
          formData.append("stcode_type", "PACKAGING");
          // console.log(file)
          try {
            pkservice.uploadPic(formData).then(async (res) => {
              //debugger
              let { status, data } = res;
              if (status === 200 && data.status === "1") {
                onUploadSuccess(file);
                onSuccess();
                message.success(`${file.name} file uploaded successfully`);
              } else {
                // alert(data.message)
              }
            });
          } catch (error) {
            onError(error);
            message.error(`${file.name} file upload failed.`);
          }
        }
        // console.log(fileList);
      } else message.error(`กรุณากรอกรหัสสินค้าก่อน.`);
    },
  };

  const Detail = (
    <>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Divider {...dividerProp}>ข้อมูลหลัก</Divider>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action !== "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item
            label={
              <span>
                <span>Packaging Code</span>
                {redcode}
              </span>
            }
            name="pk_code"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input
              addonBefore={
                <Text
                  style={{
                    width: 150,
                  }}
                >
                  {prefixSelector}
                </Text>
              }
              onChange={() => fnsetPKcode()}
              placeholder="Enter Packaging Code."
            />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={6}
          style={
            config.action === "edit" || config.action === "view"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="Packaging Code" name="pk_code1">
            <Input readOnly />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item
            label="Packaging Name"
            name="pk_name"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input placeholder="Enter Packaging Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item label="Packaging Name (English)" name="pk_nameEN">
            <Input placeholder="Enter Packaging Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item label="Express Name" name="express_name">
            <Input placeholder="Enter Express Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item label="ชื่อที่ใช้สั่งซื้อ" name="purchase_name">
            <Input placeholder="Enter Purchase Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item label="ประเภท">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="เลือกประเภท"
                value={!!formDetail.pktype_id ? formDetail.pktype_name : ""}
              />
              <Button
                type="primary"
                className="bn-primary"
                icon={<SearchOutlined />}
                style={{ minWidth: 40 }}
                onClick={() => setOpenModalPackgingType(true)}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item label="หน่วยสินค้า :" name="unit">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="Select Unit"
                value={!!formDetail.unit ? `${formDetail.unit} ` : ""}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalUnit(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item name="min_stock" label="สต๊อกขั้นต่ำ">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              placeholder="ใส่จำนวนสต๊อกขั้นต่ำ"
            />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={6}
          style={
            config.action === "edit" || config.action === "view"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="สถานะการใช้งาน" name="active_status">
            <Select
              size="large"
              options={[
                {
                  value: "เปิดการใช้งาน",
                  label: <Badge status="success" text="เปิดการใช้งาน" />,
                },
                {
                  value: "ปิดการใช้งาน",
                  label: <Badge status="error" text="ปิดการใช้งาน" />,
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
          รูปสินค้า
          <Form.Item
            name="prod_img"
            getValueFromEvent={(event) => {
              return event?.fileList;
            }}
            // rules={[
            //   {
            //     required: true,
            //     message: "กรุณาอัพโหลดรูปสินค้า!",
            //   },
            // ]}
          >
            <Upload
              {...propsAdd}
              fileList={fileList}
              listType="picture-card"
              onPreview={handlePreview}
              onRemove={onRemove}
            >
              {fileList.length >= 1 ? null : uploadButton}
            </Upload>
          </Form.Item>
        </Col>
      </Row>
      <Divider {...dividerProp}>อื่นๆ</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <Form.Item label="Remark" name="remark">
            <Input.TextArea placeholder="Enter Remark." rows={5} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  const SectionTop = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      {/* <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {!!code && (
            <ButtonUpload code={code} refer="Packaging" showExpire={true} />
          )}
        </Flex>
      </Col> */}
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      {!isView && (
        <Col span={12} style={{ paddingInline: 0 }}>
          <Flex gap={4} justify="end">
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              Save
            </Button>
          </Flex>
        </Col>
      )}
    </Row>
  );

  return (
    <div className="packaging-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Space direction="vertical" className="flex gap-2">
        {SectionTop}
        <Form form={form} layout="vertical" autoComplete="off" disabled={isView}>
          <Card title={config?.title}>{Detail}</Card>
        </Form>
        {SectionBottom}
      </Space>

      {openModalPackagingType && (
        <ModalPackagingType
          show={openModalPackagingType}
          close={() => {
            setOpenModalPackgingType(false);
          }}
          values={(v) => {
            handleChoosedPackagingType(v);
          }}
        />
      )}

      {openModalUnit && (
        <ModalUnit
          show={openModalUnit}
          close={() => {
            setOpenModalUnit(false);
          }}
          values={(v) => {
            handleChoosedUnit(v);
          }}
        />
      )}
    </div>
  );
};

export default PackagingManage;
